<template>
    <!-- Login -->
    <v-form v-if="tpl == 'reset' " ref="formCreate">
        <v-container >
            <v-row>
                <v-col
                        cols="12"
                >
                    <p class="font-weight-bold mb-1 text-center display-2">
                        Hello, {{ customer.name }}
                    </p>
                    <hr>
                </v-col>
                <v-col
                        cols="12"
                        md="6"
                        class="text-center"
                >
                    <v-text-field
                            v-model="customer.email"
                            maxlength="200"
                            counter="200"
                            label="Email"
                            required
                            :rules="emailRules"
                    ></v-text-field>
                </v-col>
                <v-col
                        cols="12"
                        md="6"
                        class="text-center"
                >
                    <v-text-field
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show1 ? 'text' : 'password'"
                            hint="At least 8 characters"
                            @click:append="show1 = !show1"
                            v-model="customer.password"
                            maxlength="100"
                            counter="100"
                            :rules="passwordRules"
                            label="Password"
                            required
                    ></v-text-field>
                </v-col>
                <v-col
                        cols="12"
                        class="text-center"
                >
                    <div v-if="erro">
                        <v-alert type="error" dense outlined  v-for="(item,index) in msg" :key="index">
                            {{ item }}
                        </v-alert>
                    </div>
                    <div v-else>
                        <v-alert type="success" dense outlined  v-for="(item,index) in msg" :key="index">
                            {{ item }}
                        </v-alert>
                    </div>
                    <v-btn
                            :loading="loading.register"
                            color="success"
                            class="mr-4"
                            @click="resetPassword"
                    >
                        <span>Continue</span>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
    <!--Loading-->
    <v-container v-else-if="tpl == 'loading' ">
        <v-row>
            <v-col
                    cols="12"
            >
                <v-card loading>
                    <v-card-text>
                        &nbsp;
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        props: {
            appUrl: { type: String },
            cdnUrl: { type: String },
        },
        metaInfo () {
            return {
                title: 'PPS Healthcare - Reset Password',
                meta: [
                    {description: 'PPS Healthcare - Account'},
                    {keywords: 'PPS Healthcare - Account'}
                ]
            }
        },
        data () {
            return {
                show1:false,
                passwordRules: [
                    v => !!v || 'password is required',
                    v => v.length >= 8 || 'Min 8 characters',
                ],
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+/.test(v) || 'E-mail must be valid',
                ],
                customer:{
                    email:"",
                    name:"",
                    telephone:"",
                    password:""
                },
                msg:[],
                erro:false,
                loading:{
                    login:false,
                    register:false,
                },
                tpl:'loading'
            }
        },
        methods:{
            resetPassword(){
                if (this.$refs.formCreate.validate()) {
                    var arr = JSON.stringify(this.customer);
                    this.$http.post(this.appUrl+"/store/customer/reset",arr).then(response => {
                        this.loading.register = false;
                        if(response.data.erro == '1'){
                            this.erro = true;
                            this.msg = response.data.msg;
                        }else{
                            localStorage.hash = response.data.data;
                            window.location.href = 'https://ppshealthcare.com/account';
                        }
                    });
                }
            },
            checkReset(){
                var query = location.search.slice(1);
                var partes = query.split('&');
                var data = {};
                partes.forEach(function (parte) {
                    var chaveValor = parte.split('=');
                    var chave = chaveValor[0];
                    var valor = chaveValor[1];
                    data[chave] = valor;
                });
                //check hasg
                var arr = {
                    hash:data.customer
                };
                arr = JSON.stringify(arr);
                this.$http.post(this.appUrl+"/store/customer/getForgot",arr).then(response => {
                    if(response.data.erro == '0'){
                        this.tpl = 'reset';
                        this.customer.name = response.data.data.name;
                        this.customer.hash = data.customer;
                        this.customer.id = response.data.data.id;
                    }
                });
            },
            init() {
                var  page = window.location.pathname.split('/');
                if(page[1] == 'pt' || page[1] == 'es'){
                    this.lang = page[1];
                }else{
                    this.lang = 'en';
                }
            },
        },
        mounted(){
            this.checkReset();
        },
        filters:{
            number_format_real(valor){
                return String(parseFloat(valor).toFixed(2));
            },
        }
    }
</script>